import React, { useState } from 'react'
import { Button, BUTTON_THEME, Icon } from '@st-operations/uikit/src/v2/index.js'

import exportPresentation from '_modules/export-svg-as-pptx/index.js'

import './ExportDialogContent.scss'
import { logErrorAsync } from '../../lib/utility'

const EXTENSIONS = [
  { name: 'pptx', title: 'Microsoft PPT', iconName: 'fileppt' },
  // { name: 'pdf', title: 'PDF', iconName: 'filepdf' },
  // { name: 'png', title: 'PNG', iconName: 'filepng' },
  // { name: 'xlsx', title: 'Excel', iconName: 'filecsv' },
  // { name: 'json', title: 'JSON', iconName: 'filejson' },
]

export const EXPORT_CLASS = 'ai-export-svg'

// component
const ExportDialogContent = ({ onClose, fileName }) => {
  const [fileType, setFileType] = useState('pptx')
  const [isLoading, setIsLoading] = useState(false)

  const handleChooseFileType = (event) => {
    setFileType(event.currentTarget.name)
  }

  const exportReport = () => {
    // generate templates, serialize slides into xml string
    const serializer = new XMLSerializer()

    const slidesSVGs = [...document.getElementsByClassName(EXPORT_CLASS)]

    const slideImages = slidesSVGs.map((slide) => serializer.serializeToString(slide))

    if (fileType === 'pptx') {
      setIsLoading(true)
      exportPresentation(
        slideImages,
        fileName ?? `ShareThis Presentation - ${new Date().toISOString().split('T')[0]}`
      )
        .then(() => {
          setIsLoading(false)
          onClose()
        })
        .catch((error) => {
          logErrorAsync(error)
          toast.error(error.message)
        })
      return
    }
  }

  return (
    <section className="export-dialog-content">
      <Button className="export-dialog-content__close" theme={BUTTON_THEME.GHOST} onClick={onClose}>
        <Icon color="#3d3d3d" icon="delete" type="fill" width="16px" height="16px" />
      </Button>

      <div className="export-dialog-content__upper-container">
        <h1 className="export-dialog-content__title">Choose file type</h1>
        <p className="export-dialog-content__help-text">
          Select which files you&#39;d like to export
        </p>
        <div className="export-dialog-content__formats">
          <For each="extension" index="index" of={EXTENSIONS}>
            <button
              key={index}
              type="button"
              onClick={handleChooseFileType}
              name={extension.name}
              className={`export-dialog-content__format ${
                extension.name === fileType ? 'active' : ''
              }`}
            >
              <Icon
                icon={extension.iconName}
                type="fill"
                width="40px"
                height="40px"
                color="#13682B"
              />
              <p className="export-dialog-content__format--text">{extension.title}</p>
            </button>
          </For>
        </div>
        <Button
          disabled={!fileType}
          className="export-dialog-content__next-button"
          name="pptx"
          onClick={exportReport}
          isLoading={isLoading}
        >
          Download
        </Button>
      </div>
    </section>
  )
}

// export
export default ExportDialogContent
